import React from 'react';
import checkIcon from '../../../../../../assets/image/check_stock_icon.svg';
import closeIcon from '../../../../../../assets/image/close.svg';
import PageLoader from '../../../../../../component/PageLoader';

export default function SubscriptionFeatures({ features, loader }) {
	return (
		<div>
			<div
				className="rounded-3 my-2"
				style={{
					border: '1px solid rgba(85, 91, 103, 0.15)',
				}}
			>
				<div className="fs-3 fw-semibold text-dark py-4 px-5">Features</div>

				<div className="subscription-border"></div>

				{loader ? (
					<PageLoader />
				) : (
					features && (
						<div className="row g-4 px-4">
							{Object.entries(features).map(([title, items], index) => (
								<div
									className="col-md-6 col-lg-4"
									key={index}
								>
									<div className="p-4">
										<h5 className="fs-4 font-medium mb-4">{title}</h5>

										{items.length > 0 ? (
											items.map((item, i) => (
												<div
													key={i}
													className="d-flex align-items-start gap-3 mb-3"
												>
													<img
														src={item.is_unlimited ? checkIcon : closeIcon}
														alt="icon"
														width={18}
														height={18}
													/>

													<span
														className="fs-5 font-small"
														style={{
															color: 'rgba(85, 91, 103, 1)',
														}}
													>
														{item.name}
													</span>
												</div>
											))
										) : (
											<div className="text-muted fs-5 font-small">No Features</div>
										)}
									</div>
								</div>
							))}
						</div>
					)
				)}
			</div>
		</div>
	);
}
